export default __webpack_public_path__ + "static/media/gl_5.0d15a92e.mp3";